import { Component } from '@angular/core';
import { AuthService } from 'src/app/component/shared/services/auth.service';

export interface NavLinkItem {
  label: string;
  path: string;
}

@Component({
  selector: 'app-vehicle-data',
  templateUrl: './vehicle-data.component.html',
  styleUrls: ['./vehicle-data.component.scss'],
})
export class VehicleDataComponent {
  constructor(private authService: AuthService) {}
  pageData = {
    id: 4,
    name: 'vehicleList',
    displayPageName: 'Vehicle List',
  };
  isNewWindow: boolean = false;
  isHasAccess: boolean = false;
  rightsError: string = '';

  ngOnInit() {
    setTimeout(() => {
      this.isHasAccess = this.authService.isHasAccess(this.pageData);
      this.rightsError = "You don't have access rights to this module.";
    }, 500);
  }

  navLinks: NavLinkItem[] = [
    {
      label: 'Vehicles',
      path: 'list/1',
    },
  ];
}
